var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { hasValue } from "./utils";
import nextId from "react-id-generator";
export var FieldStates;
(function (FieldStates) {
    FieldStates["INITIAL"] = "initial";
    FieldStates["VALID"] = "valid";
    FieldStates["ACTIVE"] = "active";
    FieldStates["READONLY"] = "readOnly";
    FieldStates["DISABLED"] = "disabled";
    FieldStates["ERROR"] = "error";
})(FieldStates || (FieldStates = {}));
var FieldContext = React.createContext({});
var Provider = FieldContext.Provider, Consumer = FieldContext.Consumer;
var FieldProvider = (function (_super) {
    __extends(FieldProvider, _super);
    function FieldProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.htmlId = nextId("oui-form-field-id-");
        _this.state = {
            focused: false,
        };
        _this.handleFocus = function (evt) {
            if (_this.props.readOnly || _this.props.disabled)
                return;
            _this.setState({ focused: true });
            _this.props.onFocus && _this.props.onFocus(evt);
        };
        _this.handleBlur = function (evt) {
            _this.setState({ focused: false });
            _this.props.onBlur && _this.props.onBlur(evt);
        };
        _this.blur = function () {
            _this.setState({ focused: false });
        };
        return _this;
    }
    FieldProvider.prototype.render = function () {
        var focused = this.state.focused;
        var _a = this.props, value = _a.value, checked = _a.checked, error = _a.error, isValid = _a.isValid, disabled = _a.disabled, readOnly = _a.readOnly;
        var fieldState = {
            checked: checked,
            focused: focused,
            isValid: isValid,
            disabled: disabled,
            readOnly: readOnly,
            hasError: Boolean(error),
            hasValue: hasValue(value),
        };
        fieldState.currentState = stateReducer(fieldState);
        return (React.createElement(Provider, { value: {
                htmlId: this.htmlId,
                fieldState: fieldState,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                blur: this.blur,
            } }, this.props.children));
    };
    return FieldProvider;
}(React.Component));
export { FieldProvider, Consumer as FieldConsumer, FieldContext };
export function stateReducer(fieldState) {
    if (fieldState.hasError) {
        return FieldStates.ERROR;
    }
    if (!fieldState.hasError && fieldState.isValid) {
        return FieldStates.VALID;
    }
    if (fieldState.focused || fieldState.checked) {
        return FieldStates.ACTIVE;
    }
    if (fieldState.readOnly) {
        return FieldStates.READONLY;
    }
    if (fieldState.disabled) {
        return FieldStates.DISABLED;
    }
    return FieldStates.INITIAL;
}
//# sourceMappingURL=FieldContext.js.map